import { render, staticRenderFns } from "./caseLabelEditor.vue?vue&type=template&id=726c5db1&scoped=true"
import script from "./caseLabelEditor.vue?vue&type=script&lang=js"
export * from "./caseLabelEditor.vue?vue&type=script&lang=js"
import style0 from "./caseLabelEditor.vue?vue&type=style&index=0&id=726c5db1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726c5db1",
  null
  
)

export default component.exports